var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "bige cont cgu", staticStyle: { "padding-top": "150px" } },
      [
        _c("h1", [_vm._v("Mentions légales")]),
        _vm._v(" "),
        _c("article", [
          _c("h2", [_vm._v("Editeur et hébergeur")]),
          _vm._v(" "),
          _c("address", [
            _c("p", [
              _vm._v(
                "\n        Okaïdi SAS au capital de 2.928.240 €, RCS Lille Métropole 398.110.445,\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n        Siège social : 162 Boulevard de Fourmies - BP 615 - 59061 Roubaix\n        Cedex 1 – France\n      "
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("\n        Tél : "),
              _c("a", { attrs: { href: "tel:+33969392390" } }, [
                _vm._v("09 69 39 23 90")
              ]),
              _vm._v(" (appel non\n        surtaxé).\n      ")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("n° TVA : TVA intracommunautaire : FR 29 398 110 445")
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v("email : "),
              _c("a", { attrs: { href: "mailto:idtroc@idkids.com" } }, [
                _vm._v("idtroc@idkids.com")
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("article", [
          _c("h2", [_vm._v("Directeur de la publication")]),
          _vm._v(" "),
          _c("p", [
            _vm._v("Grégoire Duforest, en sa qualité de Directeur Général")
          ])
        ]),
        _vm._v(" "),
        _c("article", [
          _c("h2", [_vm._v("Propriété Intellectuelle")]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "\n      L'intégralité de ce site est protégée par les législations françaises et\n      internationales relatives à la propriété intellectuelle. Tous les droits\n      de reproduction sont réservés. L'ensemble des textes composant les pages\n      du site ne peut, conformément à l'article L122-4 du code de la propriété\n      intellectuelle, faire l'objet d'une quelconque représentation ou\n      reproduction, intégrale ou partielle, sur quelque support que ce soit,\n      sans l'autorisation expresse et préalable de IDKids.\n    "
            )
          ])
        ])
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4cde841e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cde841e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MentionsLegales.vue
// module id = null
// module chunks = 